module.exports = __webpack_public_path__ + "img/BUSINESS.a9802a34.svg";